module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pillLabels":{"timeRange":"Time range","entities":"Locations & Persons","topics":"Topics","textReuseClusters":"Text reuse"},"enableRecommender":"Enable this recommender","weightLabel":"Weight","label":{"advancedSettings":"Advanced settings","resetToDefault":"Reset to default settings","applyChanges":"Apply changes"}}}')
  delete Component.options._Ctor
}
